module.exports = __webpack_public_path__ + "static/media/noCommissionIcon.d1fac208.svg";